import React from 'react'
import {
  Row, Col,
} from 'reactstrap'
import LayoutTitle from 'teleporters/LayoutTitle'
import PageTitle from 'components/common/PageTitle'
import { useFeatures } from 'components/FeaturesContext'
import { FiltersProvider, FiltersState } from 'components/charts/FiltersContext'
import { DashboardLegacyPage } from 'pages/DashboardLegacy'
import { AverageContactsPerCase } from 'components/charts/AverageContactsPerCase'
import { CheckinsByDayCard } from 'components/charts/CheckinsByDayCard'
import { OpenCasesCount } from 'components/charts/OpenCasesCount'
import Divider from 'components/common/Divider'

import { DateTime } from 'luxon'
import { BusiestSpaces } from 'components/charts/BusiestSpacesCard'

export const DashboardPage: React.FC = () => {
  const features = useFeatures()
  if (features.isLegacy) {
    return <DashboardLegacyPage />
  }

  const filters: FiltersState = {
    startDate: DateTime.local().minus({ days: 14 }).startOf('day'),
    endDate: DateTime.local().endOf('day'),
    tags: [],
  }

  return (
    <FiltersProvider {...filters}>
      <LayoutTitle.Source>
        <PageTitle>Dashboard</PageTitle>
      </LayoutTitle.Source>

      <Divider />

      <Row>
        <Col xs="12" sm="12" md="5" lg="5">
          <OpenCasesCount />
        </Col>
        <Col xs="12" sm="12" md="7" lg="5">
          <AverageContactsPerCase />
        </Col>
      </Row>
      <Row>
        <Col xs="12" sm="12" md="12" lg="10">
          <CheckinsByDayCard />
        </Col>
      </Row>
      <Row>
        <Col xs="12" sm="12" md="12" lg="10">
          <BusiestSpaces />
        </Col>
      </Row>
    </FiltersProvider>
  )
}

export default DashboardPage
